import { render, staticRenderFns } from "./issueTable.vue?vue&type=template&id=626f015e&"
import script from "./issueTable.vue?vue&type=script&lang=js&"
export * from "./issueTable.vue?vue&type=script&lang=js&"
import style0 from "./issueTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports